// src/logger.ts
var WBKLoggerImpl = class {
  logger = null;
  getLogger() {
    if (!this.logger) {
      throw new Error(
        "Logger instance is not initialized, See instructions in https://github.com/nadude/webook-frontend/blob/main/packages/logger/README.md"
      );
    }
    return this.logger;
  }
  get isInitialized() {
    return !!this.logger;
  }
  init(logger) {
    this.logger = logger;
  }
  captureException(exception, context) {
    return this.getLogger().captureException(exception, context);
  }
  captureMessage(message, context) {
    return this.getLogger().captureMessage(message, context);
  }
  setUser(user) {
    return this.getLogger().setUser(user);
  }
  showReportDialog(options) {
    return this.getLogger().showReportDialog(options);
  }
  lastId() {
    return this.getLogger().lastId();
  }
};
var Logger = new WBKLoggerImpl();

export {
  Logger
};
//# sourceMappingURL=chunk-MG6YGXXR.mjs.map